/**
 * Created by nijin on 22/12/16.
 */
import {Component, OnInit, OnDestroy, Input, ViewChild} from '@angular/core';
import {WizardBaseContentComponent} from "../shared/wizard/wiz-base.component";
import {ThingsService} from "../things.service";
import {FormBuilder, Validators, FormGroup} from "@angular/forms";
import {NotificationType} from "../../core/notify/index";
import {NotificationBarService} from "../../core/notify/notification.service";
import {SchemaService} from "../../schema/schema.service";
import {ConnectionListComponent} from "../shared/connection-list/connection-list.component";

@Component({
    selector: 'nuc-select-connection',
    templateUrl: './select-connection.html',
})
export class SelectConnectionComponent extends WizardBaseContentComponent{

  isValidState:boolean = true;
  isLoading: boolean = true;
  defaultConnection = {id: 2};
  connection: any;

  @ViewChild ('connectionList') connectionList: ConnectionListComponent;

  @Input() isMobileApp: boolean = false;

  constructor(
    private thingsService: ThingsService,
    private schemaService: SchemaService) {
    super();
  }


  canMoveForward(){
    return this.connectionList.isValid();
  }
  selectConnection(connection){
    this.isValidState = true;
    this.connection = connection;
  }
  onValidState(subject, nextStep){
    this.thingsService.setThingConnection(this.connection);
    this.saveThing(subject, nextStep);
    //subject.next(nextStep);
  }
  private saveThing(subject, next){
    this.isLoading = true;
    if(this.isMobileApp){
      this.thingsService.saveAppDetails()
        .subscribe((response) =>{
          this.onThingCreateSuccess(response, subject,next, true);
        },(error)=>{this.isLoading = false; });

    }
    else{
      this.thingsService.saveThing()
        .subscribe((response)=> {
            this.onThingCreateSuccess(response, subject, next,false)
          },
          (error)=>{this.isLoading = false; })
    }

  };


  private  onThingCreateSuccess(response, subject, next, isApp){
    subject.next(next);
    this.isLoading = false;
    this.schemaService.resetThingToken();
    this.thingsService.updateThingSubject(response, isApp);
  }

  onInvalidState(){
    this.isValidState = false;
  }

  onLoadingComplete(event) {
    this.isLoading = false;
  }




  preview(){

  }


}



// WEBPACK FOOTER //
// ./src/app/things/onboard/select-connection.component.ts